export const CLINIC_IDS = {
  MUKUND_NAGAR: 1,
  RASTA_PETH: 2,
  KOTHRUD: 3,
} as const;

const CLINIC_NAMES: Record<number, string> = {
  [CLINIC_IDS.MUKUND_NAGAR]: 'Mukund Nagar',
  [CLINIC_IDS.RASTA_PETH]: 'Rasta Peth',
  [CLINIC_IDS.KOTHRUD]: 'Kothrud',
};

/** Exact reception login emails mapped to their clinic. */
const LOGIN_EMAIL_CLINIC_MAP: Record<string, number> = {
  'mukundnaagr@gmail.com': CLINIC_IDS.MUKUND_NAGAR,
  'kothrud@gmail.com': CLINIC_IDS.KOTHRUD,
  'rastapeth@gmail.com': CLINIC_IDS.RASTA_PETH,
};

/** Legacy user-id mapping kept as fallback. */
const LOGIN_USER_ID_CLINIC_MAP: Record<number, number> = {
  4: CLINIC_IDS.MUKUND_NAGAR,
  6: CLINIC_IDS.RASTA_PETH,
  7: CLINIC_IDS.KOTHRUD,
};

export function getClinicName(clinicId: number): string {
  return CLINIC_NAMES[clinicId] ?? '';
}

export function resolveClinicIdFromLogin(user: any): number | null {
  const apiClinicId = Number(user?.default_clinic_id);
  if (Number.isFinite(apiClinicId) && apiClinicId > 0) {
    return apiClinicId;
  }

  const email = String(user?.email ?? '').trim().toLowerCase();
  if (email && LOGIN_EMAIL_CLINIC_MAP[email]) {
    return LOGIN_EMAIL_CLINIC_MAP[email];
  }

  if (email.includes('mukund')) {
    return CLINIC_IDS.MUKUND_NAGAR;
  }
  if (email.includes('kothrud')) {
    return CLINIC_IDS.KOTHRUD;
  }
  if (email.includes('rastapeth') || email.includes('rasta')) {
    return CLINIC_IDS.RASTA_PETH;
  }

  const userId = Number(user?.id);
  if (Number.isFinite(userId) && LOGIN_USER_ID_CLINIC_MAP[userId]) {
    return LOGIN_USER_ID_CLINIC_MAP[userId];
  }

  return null;
}

export function storeLoginClinicContext(user: any): number | null {
  const clinicId = resolveClinicIdFromLogin(user);
  if (clinicId == null) {
    return null;
  }

  sessionStorage.setItem('clinic_id', String(clinicId));
  sessionStorage.setItem('clinic_name', getClinicName(clinicId));
  return clinicId;
}
